import React from "react";
import { Card, Empty } from "antd";
import { LineChartOutlined } from "@ant-design/icons";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { format } from "date-fns";

const TimelineChart = ({ timeline }) => {
  if (!timeline || timeline.length === 0) {
    return (
      <Card
        title={
          <span>
            <LineChartOutlined style={{ marginRight: 8, color: "#1890ff" }} />
            Email Activity Timeline
          </span>
        }
        bordered={false}
        style={{ height: "100%", minHeight: 380 }}
        bodyStyle={{ display: "flex", alignItems: "center", justifyContent: "center", height: "calc(100% - 57px)" }}
      >
        <Empty description="No timeline data available" />
      </Card>
    );
  }

  const formattedData = timeline.map((item) => ({
    ...item,
    date: format(new Date(item.date), "MMM dd"),
  }));

  return (
    <Card
      title={
        <span>
          <LineChartOutlined style={{ marginRight: 8, color: "#1890ff" }} />
          Email Activity Timeline
        </span>
      }
      bordered={false}
      style={{ height: "100%", minHeight: 380 }}
    >
      <ResponsiveContainer width="100%" height={280}>
        <LineChart data={formattedData} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis
            dataKey="date"
            tick={{ fontSize: 12 }}
            axisLine={{ stroke: "#d9d9d9" }}
            tickLine={{ stroke: "#d9d9d9" }}
          />
          <YAxis
            tick={{ fontSize: 12 }}
            axisLine={{ stroke: "#d9d9d9" }}
            tickLine={{ stroke: "#d9d9d9" }}
            allowDecimals={false}
          />
          <Tooltip
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #f0f0f0",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
            }}
          />
          <Legend wrapperStyle={{ paddingTop: 10 }} />
          <Line
            type="monotone"
            dataKey="sent"
            stroke="#1890ff"
            strokeWidth={2}
            name="Sent"
            dot={{ r: 4, fill: "#1890ff" }}
            activeDot={{ r: 6 }}
          />
          <Line
            type="monotone"
            dataKey="opened"
            stroke="#52c41a"
            strokeWidth={2}
            name="Opened"
            dot={{ r: 4, fill: "#52c41a" }}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default TimelineChart;
